<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索区域 -->
      <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
              size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="订单号">
              <el-input v-model="searchForm.withdraw_sn" clearable type="text" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="searchForm.pay_status_w" clearable placeholder="请选择状态">
                <el-option label="待处理" :value="0"></el-option>
                <el-option label="处理中" :value="1"></el-option>
                <el-option label="成功" :value="2"></el-option>
                <el-option label="失败" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提现日期">
              <el-date-picker
                      v-model="searchForm.dateRange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="timestamp"
                      :clearable="true">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="searchSubmit()">搜索</el-button>
              <el-button type="default" @click="resetSearch()">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 金额统计区域 -->
      <el-row :gutter="20" style="margin-bottom: 15px;">
        <el-col :span="6">
          <el-card shadow="hover" class="amount-card">
            <div class="amount-item">
              <div class="amount-label">可提现金额</div>
              <div class="amount-value primary">{{total_order_amount || 0}} 元</div>
            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="6">-->
<!--          <el-card shadow="hover" class="amount-card">-->
<!--            <div class="amount-item">-->
<!--              <div class="amount-label">手续费金额</div>-->
<!--              <div class="amount-value warning">{{service_charge_amount || 0}} 元</div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
<!--        <el-col :span="6">-->
<!--          <el-card shadow="hover" class="amount-card">-->
<!--            <div class="amount-item">-->
<!--              <div class="amount-label">实际到账金额</div>-->
<!--              <div class="amount-value success">{{actual_amount || 0}} 元</div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
        <el-col :span="6">
          <el-card shadow="hover" class="amount-card">
            <div class="amount-item">
              <div class="amount-label">总可提现记录数</div>
              <div class="amount-value info">{{total || 0}} 条</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 操作区域 -->
      <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-button
                  type="warning"
                  size="mini"
                  :disabled="multipleSelection.length === 0"
                  @click="batchWithdraw"
                  icon="el-icon-money">
            批量提现 ({{multipleSelection.length}})
          </el-button>

          <el-button
                  type="info"
                  size="mini"
                  @click="exportData"
                  icon="el-icon-download">
            导出数据
          </el-button>
        </div>
        <div>
          <el-tag type="info">选中金额: {{batchTotalAmount}} 元</el-tag>
        </div>
      </div>

      <!-- 表格区域 -->
      <el-table
              ref="multipleTable"
              :data="tableLoadData"
              height="450"
              stripe
              border
              size="mini"
              @selection-change="handleSelectionChange"
              v-loading="loading"
      >
        <el-table-column
                type="selection"
                width="55">
        </el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
                label="交易日期"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time | timeFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="交易金额(元)"
                width="100"
                align="right"
        >
          <template slot-scope="scope">
            <span style="font-weight: bold; color: #e6a23c;">{{ scope.row.order_amount }}</span>
          </template>
        </el-table-column>

        <el-table-column
                label="油站名称"
                width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.oilshop?scope.row.oilshop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="运企名称"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lgsshop?scope.row.lgsshop.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="司机手机"
                width="100"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.owner?scope.row.owner.tel:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="司机姓名"
                width="120"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.owner?scope.row.owner.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="车牌号"
                width="100"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.carinfo?scope.row.carinfo.car_number:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="开票状态"
                :show-overflow-tooltip='true'
                width="100"
        >
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: column;">
              <el-tag v-if="scope.row.is_invoice==1" type="success" size="mini">已开票</el-tag>
              <el-tag v-else type="info" size="mini">未开票</el-tag>
              <span style="font-size: 10px; color: #909399;" v-if="scope.row.is_invoice==1">
                {{ scope.row.time_invoice | timeFormat }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                label="支付状态"
                :show-overflow-tooltip='true'
                width="100"
        >
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: column;">
            <el-tag v-if="scope.row.pay_status==2" type="success" size="mini">已支付</el-tag>
            <el-tag v-else type="warning" size="mini">未支付</el-tag>
            <span style="font-size: 10px; color: #909399;" v-if="scope.row.is_invoice==1">
                {{ scope.row.pay_time | timeFormat }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                label="操作"
                width="120"
                fixed="right"
        >
          <template slot-scope="scope">
            <el-button
                    @click="viewDetail(scope.row)"
                    type="text"
                    size="mini"
                    icon="el-icon-view">
              详情
            </el-button>
            <el-button
                    @click="handleWithdraw(scope.row)"
                    type="text"
                    size="mini"
                    :disabled="scope.row.pay_status == 2"
                    icon="el-icon-money"
                    v-if="scope.row.pay_status != 2">
              提现
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 批量提现确认对话框 -->
    <el-dialog
            title="批量提现确认"
            :visible.sync="batchDialogVisible"
            width="40%">
      <div style="padding: 10px 0;">
        <p style="margin-bottom: 15px;">您确定要对选中的 <span style="color: #e6a23c; font-weight: bold">{{multipleSelection.length}}</span> 条记录进行提现操作吗？</p>

        <el-divider></el-divider>

        <div style="margin: 15px 0;">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="confirm-item">
                <span class="confirm-label">总提现金额：</span>
                <span class="confirm-value primary">{{batchTotalAmount}} 元</span>
              </div>
            </el-col>
<!--            <el-col :span="12">-->
<!--              <div class="confirm-item">-->
<!--                <span class="confirm-label">总手续费：</span>-->
<!--                <span class="confirm-value warning">{{calculateBatchServiceCharge()}} 元</span>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--          <el-row :gutter="20" style="margin-top: 10px;">-->
<!--            <el-col :span="12">-->
<!--              <div class="confirm-item">-->
<!--                <span class="confirm-label">实际到账金额：</span>-->
<!--                <span class="confirm-value success">{{calculateBatchActualAmount()}} 元</span>-->
<!--              </div>-->
<!--            </el-col>-->
            <el-col :span="12">
              <div class="confirm-item">
                <span class="confirm-label">提现笔数：</span>
                <span class="confirm-value info">{{multipleSelection.length}} 笔</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-divider></el-divider>

        <p style="color: #f56c6c; font-size: 12px;">
          <i class="el-icon-warning"></i> 提示：提现操作一旦提交，将无法撤销，请仔细核对信息。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchWithdraw" :loading="batchLoading">确 定 提 现</el-button>
      </span>
    </el-dialog>

    <!-- 提现详情对话框 -->
    <el-dialog
            title="订单详情"
            :visible.sync="detailDialogVisible"
            width="60%">
      <order-detail :order-data="currentOrder" v-if="detailDialogVisible"></order-detail>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "withdrawList",
    components: {
      // 假设有一个订单详情组件
      'order-detail': {
        template: `<div>订单详情组件</div>`,
        props: ['orderData']
      }
    },
    props: {},
    data() {
      return {
        total_order_amount: 0,
        service_charge_amount: 0, // 手续费总额
        actual_amount: 0, // 实际到账总额
        service_charge_rate: 0.006, // 手续费率，默认0.6%

        loading: false,
        batchLoading: false,

        // 搜索表单
        searchForm: {
          withdraw_sn: "",
          pay_status_w: "",
          dateRange: []
        },

        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },

        // 表格数据
        tableLoadData: [],
        pageNum: 1,
        pageSize: 15,
        total: 0,
        multipleSelection: [],

        // 批量提现相关
        batchDialogVisible: false,
        batchTotalAmount: 0,

        // 详情对话框
        detailDialogVisible: false,
        currentOrder: {}
      };
    },
    created() {
      this.DataList();
      this.calculateTotalAmounts();
    },
    filters: {
      // 时间格式化
      timeFormat(time) {
        if (!time) return "";
        return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
      // 日期格式化
      dateFormat(date) {
        if (!date) return "";
        return moment(date * 1000).format("YYYY-MM-DD");
      }
    },
    methods: {
      // 计算单笔手续费
      calculateServiceCharge(amount) {
        return (amount * this.service_charge_rate).toFixed(2);
      },

      // 计算单笔实际到账金额
      calculateActualAmount(amount) {
        return (amount - amount * this.service_charge_rate).toFixed(2);
      },

      calculateTotalAmount() {
        return this.multipleSelection.reduce((total, item) => {
          return total + parseFloat(item.order_amount);
        }, 0).toFixed(2);
      },
      // 计算批量手续费
      calculateBatchServiceCharge() {
        return this.multipleSelection.reduce((total, item) => {
          return total + parseFloat(item.amount);
        }, 0).toFixed(2);
      },

      // 计算批量实际到账金额
      calculateBatchActualAmount() {
        return this.multipleSelection.reduce((total, item) => {
          return total + parseFloat(item.withdraw_amount);
        }, 0).toFixed(2);
      },

      // 计算总金额
      calculateTotalAmounts() {
        // 这里应该是从API获取的数据，暂时用表格数据计算
        this.total_order_amount = this.tableLoadData.reduce((total, item) => {
          return total + (parseFloat(item.order_amount) || 0);
        }, 0).toFixed(2);

        this.service_charge_amount = this.tableLoadData.reduce((total, item) => {
          return total + parseFloat(item.amount);
        }, 0).toFixed(2);

        this.actual_amount = this.tableLoadData.reduce((total, item) => {
          return total + parseFloat(item.withdraw_amount);
        }, 0).toFixed(2);
      },

      // 表格选择变化
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.batchTotalAmount = val.reduce((total, item) => {
          return total + (parseFloat(item.order_amount) || 0);
        }, 0).toFixed(2);
      },
      showAlert() {
        // 防止当天重复提示
        const today = new Date().toDateString();
        const lastAlertDate = localStorage.getItem('lastAlertDate');

        if (lastAlertDate !== today && !this.hasShownAlert) {
          this.$alert('现在是 0:00 到 10:00 之间，提现不要在这个时间段！', '时间提示', {
            confirmButtonText: '确定',
            callback: () => {
              // 记录本次提示日期
              localStorage.setItem('lastAlertDate', today);
              this.hasShownAlert = true;
            }
          });
        }
      },
      // 批量提现
      batchWithdraw() {

        const now = new Date();
        const currentHour = now.getHours();
        //const currentMinute = now.getMinutes();

        // 检查是否在 0:00 到 10:00 之间
        if (currentHour >= 0 && currentHour <= 10) {
          this.showAlert();
          return;
        }

        if (this.multipleSelection.length === 0) {
          this.$message.warning('请先选择要提现的记录');
          return;
        }

        // 检查是否有已经提现成功的记录
        const hasSuccess = this.multipleSelection.some(item => item.is_withdraw == 1);
        if (hasSuccess) {
          this.$message.warning('选中的记录中包含已提现成功的记录，无法重复提现');
          return;
        }

        this.batchDialogVisible = true;
      },

      // 确认批量提现
      confirmBatchWithdraw() {
        this.batchLoading = true;
        const ids = this.multipleSelection.map(item => item.id);

        // 调用批量提现接口
        const param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          ids: ids,
          total_order_amount: this.calculateTotalAmount(),//订单总金额
          service_charge_amount: this.calculateBatchServiceCharge(), // 手续费总额
          actual_amount: this.calculateBatchActualAmount(), // 实际到账总额
        };
        this.$axios.withdrawOilSave(param).then(res=>{
              if(res.code==200){
                  this.$message.success(`成功提交 ${this.multipleSelection.length} 条提现申请，总金额 ${this.batchTotalAmount} 元`);
                  this.batchDialogVisible = false;
                  this.batchLoading = false;
                  this.DataList();
                  this.$refs.multipleTable.clearSelection();
              }
        });
        console.log(param)

      },

      // 单条记录提现
      handleWithdraw(row) {
        this.$confirm(`确定要对订单 ${row.order_sn} 进行提现操作吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            id: row.id
          };
          console.log(param)
          //
          // // 模拟API调用
          // this.$message.success(`提现申请已提交，金额 ${row.order_amount} 元`);
          this.DataList();
        }).catch(() => {
          // 用户取消操作
        });
      },

      // 查看详情
      viewDetail(row) {
        this.currentOrder = row;
        this.detailDialogVisible = true;
      },

      // 导出数据
      exportData() {
        const now = new Date();
        const currentHour = now.getHours();
        //const currentMinute = now.getMinutes();

        // 检查是否在 0:00 到 10:00 之间
        if (currentHour >= 0 && currentHour <= 10) {
          this.showAlert();
          return;
        }

        this.$message.info('导出功能开发中...');
      },

      // 重置搜索条件
      resetSearch() {
        this.searchForm = {
          withdraw_sn: "",
          pay_status_w: "",
          dateRange: []
        };
        this.pageNum = 1;
        this.DataList();
      },

      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1;
      },

      DataList(){
        this.loading = true;
        const param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          param.start_time = this.searchForm.dateRange[0] / 1000;
          param.end_time = this.searchForm.dateRange[1] / 1000;
        }

        if (this.searchForm.withdraw_sn) {
          param.withdraw_sn = this.searchForm.withdraw_sn;
        }

        if (this.searchForm.pay_status_w !== "") {
          param.pay_status_w = this.searchForm.pay_status_w;
        }

        this.$axios.findByNoWithdrawListP(param).then(res => {
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total = res.data.total;
            this.calculateTotalAmounts();
          }
          this.loading = false;
        }).catch(error => {
          console.log(error);
          this.loading = false;
        });
      },

      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.DataList();
      },

      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.DataList();
      },

      searchSubmit() {
        this.pageNum = 1;
        this.DataList();
      }
    },
  };
</script>

<style scoped>
  .amount-card {
    border-radius: 4px;
    border-left: 4px solid #e6a23c;
  }

  .amount-card .amount-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
  }

  .amount-card .amount-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 5px;
  }

  .amount-card .amount-value {
    font-size: 18px;
    font-weight: bold;
  }

  .amount-value.primary {
    color: #e6a23c;
  }

  .amount-value.warning {
    color: #f56c6c;
  }

  .amount-value.success {
    color: #67c23a;
  }

  .amount-value.info {
    color: #909399;
  }

  .confirm-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .confirm-label {
    color: #606266;
  }

  .confirm-value {
    font-weight: bold;
  }

  .confirm-value.primary {
    color: #e6a23c;
  }

  .confirm-value.warning {
    color: #f56c6c;
  }

  .confirm-value.success {
    color: #67c23a;
  }

  .confirm-value.info {
    color: #909399;
  }

  /* 响应式调整 */
  @media screen and (max-width: 1200px) {
    .el-col-6 {
      width: 50%;
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    .el-col-6 {
      width: 100%;
    }
  }
</style>
